module.exports = __webpack_public_path__ + "img/hotsys_2.f104af59.png";